// extracted by mini-css-extract-plugin
export var exampleCard = "styles-module--exampleCard--b6f48";
export var exampleList = "styles-module--exampleList--8b128";